import React from "react";
import classnames from "classnames";

export default class ChartSettings extends React.Component {
	constructor() {
		super();
		this.handleShowGridToggle = this.handleShowGridToggle.bind(this);
	}
	handleShowGridToggle() {
		let { settings } = this.props;
		this.props.onChangeSettings({
			...settings,
			showGrid: !settings.showGrid
		});
		// console.log("toggleGrid ", settings);
	}
	render() {
		let classes = classnames({
			"chart-settings": true,
			"pull-right": false,
			"btn-group": true,
			"dropdown-menu-right": true,
			"open": this.props.showDropDown,
		});
		let { settings } = this.props;
		return (
			<div className={classes} data-intro="change settings for the chart">
				<button type="button" className="btn btn-default" onClick={this.props.onDropDownToggle}>
					<span className="glyphicon glyphicon-cog"></span>
				</button>
				<ul className="dropdown-menu chart-settings-menu">
					<li key="0" onClick={this.handleShowGridToggle}>
						<div className="clearfix">
							<span className="pull-left">
								Grid
							</span>
							<div className="pull-right">
								<label className={classnames({ "btn": true, "btn-success active": settings.showGrid, "btn-default": !settings.showGrid})}>
									{(settings.showGrid ? "ON" : "OFF")}
								</label>
							</div>
						</div>
					</li>
					<li key="1">
						<div className="clearfix">
							<span className="pull-left">
								Another setting here
							</span>
						</div>
					</li>
					<li key="2">
						<div className="clearfix">
							<span className="pull-left">
								Another setting here..
							</span>
						</div>
					</li>
				</ul>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartSettings.jsx
 **/